module.exports = __webpack_public_path__ + "img/subject_gift_banner.911c9f7d.png";